module.exports = __webpack_public_path__ + "static/media/ordersOn.7d97f0dd.svg";